import { render, staticRenderFns } from "./UserBasicInfoForm.vue?vue&type=template&id=2490777c&"
import script from "./UserBasicInfoForm.vue?vue&type=script&lang=js&"
export * from "./UserBasicInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UserBasicInfoForm.vue"
export default component.exports